import AdminIndex from "@/views/admin/AdminIndex.vue";

const admin = [
    {
        path: '/admin',
        name: 'admin',
        component: AdminIndex
    }
]

export default admin;